const apiUrl = process.env.REACT_APP_API_URL;

export const GetCazaAlumnos = async (idCaza: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/caza/${idCaza}/alumnos`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        if (response.ok) {
            return await response.json();
        }
        return [];
    } catch (error) {
        console.log('Error fetching Caza alumnos:', error);
        return [];
    }
};
